module.exports = new __parcel__URL__("MMIRL5.c30db982.jpg").toString();